import _ from 'lodash'
import React from 'react'
import T from 'prop-types'
import ReactDOM from 'react-dom'
import cx from 'classnames'
import ColumnShape from './ColumnShape'
import {
  removeDragImage,
  getCurrentDragClientXY
} from '../../utils'

const MIN_RESIZE_WIDTH = 30

class ColHeader extends React.Component {
  static displayName = 'DataTable_ColumnHeader'

  static propTypes = {
    cellProps: T.object, // Optional additional props to pass to a renderHeader function
    column: T.shape(ColumnShape).isRequired,
    sorted: T.oneOf(['asc', 'desc']),
    onSort: T.func, //(columnDef, asc_or_desc)
    onResizeStart: T.func, //(columnDef, startWidth)
    onResizeEnd: T.func, //(columnDef, newWidth)
    onDragStart: T.func,
    className: T.string
  }

  state = {
    resizing: false,
    currentWidth: 0
  }

  UNSAFE_componentWillMount() {
    this.setState({
      currentWidth: this.props.column.width
    })
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const newWidth = newProps.column.width
    if (newWidth !== this.state.currentWidth) {
      this.setState({ currentWidth: newWidth })
    }
  }

  _getCurrentSort = () => {
    const { sorted, column } = this.props
    return column.sortable && sorted ? sorted : null
  }

  _onClick = () => {
    const { column, sorted } = this.props
    if (column.sortable) {
      this.props.onSort(
        column,
        sorted
          ? sorted === 'desc' ? 'asc' : 'desc'
          : column.initialSortDir || 'asc'
      )
    }
  }

  _onResizeStart = e => {
    const startWidth = ReactDOM.findDOMNode(this).offsetWidth
    const startX = e.clientX
    this.props.onResizeStart(this.props.column, startWidth)
    this.setState({
      resizing: {
        startX: startX,
        startWidth: startWidth
      }
    })
    e.dataTransfer.setData('x-none', '')
    removeDragImage(e)
    e.stopPropagation()
  }

  _onResizeMove = e => {
    const resizing = this.state.resizing
    const clientXY = getCurrentDragClientXY()
    if (resizing) {
      const newWidth = Math.max(
        resizing.startWidth + (clientXY.x - resizing.startX),
        MIN_RESIZE_WIDTH
      )
      this.setState({
        currentWidth: newWidth
      })
    }
    e.stopPropagation()
  }

  _onResizeEnd = e => {
    const resizing = this.state.resizing
    const clientXY = getCurrentDragClientXY()
    if (resizing) {
      const newWidth = Math.max(
        resizing.startWidth + (clientXY.x - resizing.startX),
        MIN_RESIZE_WIDTH
      )
      this.props.onResizeEnd(this.props.column, newWidth)
      this.setState({
        resizing: false,
        currentWidth: newWidth
      })
    }
    e.stopPropagation()
  }

  render() {
    const { props, state } = this
    const { cellProps, column } = props
    const sortDir = this._getCurrentSort()
    const sortable = !!column.sortable
    const resizable = !!column.resizable
    const fixed = !!column.fixed
    const resizing = state.resizing
    const classes = cx(
      column.headerClass,
      sortDir && 'sorted',
      sortable && 'sortable',
      resizable && 'resizable',
      props.className
    )
    const style = _.assign(
      {
        minWidth: state.currentWidth || 0
      },
      props.style
    )

    return (
      <th
        className={classes}
        style={style}
        data-columnkey={column.key}
        draggable={!!props.onDragStart}
        onDragStart={props.onDragStart}
        onDrag={props.onDrag}
        onDragEnd={props.onDragEnd}
        aria-sort={sortDir === 'asc' ? 'ascending' : sortDir === 'desc' ? 'descending' : 'none'}
      >
        <span
          className="text"
          data-tooltip={column.headerTooltip || null}
          onClick={this._onClick}
        >
          {column.renderHeader ? column.renderHeader(cellProps) : column.header}
          {column.sortable
            ? <span
                className={cx('caret', sortDir === 'asc' && 'caret-reversed')}
                role="button"
                aria-label="Sort"
              />
            : null}
        </span>
        {resizable
          ? <span
              className={cx('resizer enabled', resizing && 'resizing')}
              draggable
              onDragStart={this._onResizeStart}
              onDrag={this._onResizeMove}
              onDragEnd={this._onResizeEnd}
              data-tooltip={!resizing ? 'Drag to resize' : null}
            />
          : !fixed ? <span className="resizer disabled" /> : null}
      </th>
    )
  }
}

export default ColHeader
